module.exports = __webpack_public_path__ + "static/media/lvjian-tz.5da0819e.jpg";